import * as fromDatatype from '../datatype-library/index';

export interface bl_crm_membership_points_txn_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_hdr_1: fromDatatype.GuidDataFieldInterface;
  guid_line_1: fromDatatype.GuidDataFieldInterface;
  date_hdr_1: fromDatatype.TimestampTzDatatypeInterface;
  date_line_1: fromDatatype.TimestampTzDatatypeInterface;
  guid_hdr_2: fromDatatype.GuidDataFieldInterface;
  guid_line_2: fromDatatype.GuidDataFieldInterface;
  date_hdr_2: fromDatatype.TimestampTzDatatypeInterface;
  date_line_2: fromDatatype.TimestampTzDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  login: fromDatatype.VarcharDatatypeInterface;
  option: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  quantity_contra: fromDatatype.NumericDatatypeInterface;
  quantity_signum: fromDatatype.NumericDatatypeInterface;
  amount_contra: fromDatatype.MoneyDatatypeInterface;
  amount_signum: fromDatatype.MoneyDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_crm_membership_points_txn_link_RowClass implements bl_crm_membership_points_txn_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_hdr_1: fromDatatype.GuidDataFieldInterface;
  guid_line_1: fromDatatype.GuidDataFieldInterface;
  date_hdr_1: fromDatatype.TimestampTzDatatypeInterface;
  date_line_1: fromDatatype.TimestampTzDatatypeInterface;
  guid_hdr_2: fromDatatype.GuidDataFieldInterface;
  guid_line_2: fromDatatype.GuidDataFieldInterface;
  date_hdr_2: fromDatatype.TimestampTzDatatypeInterface;
  date_line_2: fromDatatype.TimestampTzDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  login: fromDatatype.VarcharDatatypeInterface;
  option: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  quantity_contra: fromDatatype.NumericDatatypeInterface;
  quantity_signum: fromDatatype.NumericDatatypeInterface;
  amount_contra: fromDatatype.MoneyDatatypeInterface;
  amount_signum: fromDatatype.MoneyDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}


